import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';

export default defineModule({
    name: 'orders',
    routes: [
        {
            path: '/order',
            meta: {
                layout: 'overlay',
                transition: 'fade',
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
            children: [
                {
                    path: '',
                    name: 'new product',
                    component: () => import('#modules/orders/pages/index.vue'),
                },
                {
                    path: 'domain',
                    name: 'new domain',
                    component: () => import('#modules/orders/pages/domain.vue'),
                },
                {
                    path: 'ssl',
                    name: 'new ssl',
                    component: () => import('#modules/orders/pages/ssl.vue'),
                },
            ],
        },

        {
            path: '/support/migration',
            name: 'migration',
            component: () => import('#modules/orders/pages/migration/MigrationTypeSelect.vue'),
            meta: {
                layout: 'overlay',
            },
        },
        {
            path: '/support/migration/start',
            name: 'migration-start',
            component: () => import('#modules/orders/pages/migration/MigrationOrder.vue'),
            meta: {
                layout: 'overlay',
            },
        },
        {
            path: '/support/migration/control-panel',
            name: 'migration-control-panel',
            component: () => import('#modules/orders/pages/migration/MigrationOrder.vue'),
            meta: {
                layout: 'overlay',
            },
        },
        {
            path: '/support/migration/mailbox',
            name: 'migration-mailbox',
            component: () => import('#modules/orders/pages/migration/MigrationOrder.vue'),
            meta: {
                layout: 'overlay',
            },
        },
    ],
});
